export enum ToolEnum {
  Select = 'Select',
  Hide = 'Hide',
  Paint = 'Paint',
  Eyedropper = 'Eyedropper',
  Label = 'Label',
  Isolate = 'Isolate',
  Fade = 'Fade',
  Position = 'Position',
  Quiz = 'Quiz',
}
